export enum LoginErrorStatusEnum {
  EMAIL_NOT_FOUND = 'EMAIL_NOT_FOUND',
  PASSWORD_INVALID = 'PASSWORD_INVALID',
  IP_INVALID = 'IP_INVALID'
}

export enum LoginErrorTextEnum {
  TITLE = '로그인에 실패하였습니다.',
  EMAIL_NOT_FOUND = `아이디가 올바르지 않습니다.
다시 확인해 주세요!`,
  PASSWORD_INVALID = `비밀번호가 올바르지 않습니다.
다시 확인해 주세요!`,
  IP_INVALID = '접속이 허용되지 않은 IP입니다.',
  UNKNOWN_ERROR = `Unknown error occurred. Please try again later.`
}
